__turbopack_context__.v({
  "ab": "mojumoncrimson-module__nF9oZq__ab",
  "actions": "mojumoncrimson-module__nF9oZq__actions",
  "active": "mojumoncrimson-module__nF9oZq__active",
  "art-close": "mojumoncrimson-module__nF9oZq__art-close",
  "art-frame": "mojumoncrimson-module__nF9oZq__art-frame",
  "art-modal": "mojumoncrimson-module__nF9oZq__art-modal",
  "art-open": "mojumoncrimson-module__nF9oZq__art-open",
  "art-viewer": "mojumoncrimson-module__nF9oZq__art-viewer",
  "artPop": "mojumoncrimson-module__nF9oZq__artPop",
  "blink": "mojumoncrimson-module__nF9oZq__blink",
  "bob": "mojumoncrimson-module__nF9oZq__bob",
  "btn": "mojumoncrimson-module__nF9oZq__btn",
  "btn-primary": "mojumoncrimson-module__nF9oZq__btn-primary",
  "btn-secondary": "mojumoncrimson-module__nF9oZq__btn-secondary",
  "case-code": "mojumoncrimson-module__nF9oZq__case-code",
  "cj-patrol": "mojumoncrimson-module__nF9oZq__cj-patrol",
  "cj-pose": "mojumoncrimson-module__nF9oZq__cj-pose",
  "cj-poses": "mojumoncrimson-module__nF9oZq__cj-poses",
  "cj-route": "mojumoncrimson-module__nF9oZq__cj-route",
  "cj-walker": "mojumoncrimson-module__nF9oZq__cj-walker",
  "cjPatrol": "mojumoncrimson-module__nF9oZq__cjPatrol",
  "cjWalkCycle": "mojumoncrimson-module__nF9oZq__cjWalkCycle",
  "console": "mojumoncrimson-module__nF9oZq__console",
  "console-controls": "mojumoncrimson-module__nF9oZq__console-controls",
  "console-glow": "mojumoncrimson-module__nF9oZq__console-glow",
  "console-wrap": "mojumoncrimson-module__nF9oZq__console-wrap",
  "consoleReveal": "mojumoncrimson-module__nF9oZq__consoleReveal",
  "controller-help": "mojumoncrimson-module__nF9oZq__controller-help",
  "crimson": "mojumoncrimson-module__nF9oZq__crimson",
  "cta": "mojumoncrimson-module__nF9oZq__cta",
  "dex-number": "mojumoncrimson-module__nF9oZq__dex-number",
  "dojo": "mojumoncrimson-module__nF9oZq__dojo",
  "dojo-panel": "mojumoncrimson-module__nF9oZq__dojo-panel",
  "dpad": "mojumoncrimson-module__nF9oZq__dpad",
  "dpad-down": "mojumoncrimson-module__nF9oZq__dpad-down",
  "dpad-key": "mojumoncrimson-module__nF9oZq__dpad-key",
  "dpad-left": "mojumoncrimson-module__nF9oZq__dpad-left",
  "dpad-right": "mojumoncrimson-module__nF9oZq__dpad-right",
  "dpad-up": "mojumoncrimson-module__nF9oZq__dpad-up",
  "driplett": "mojumoncrimson-module__nF9oZq__driplett",
  "embrawl": "mojumoncrimson-module__nF9oZq__embrawl",
  "eyebrow": "mojumoncrimson-module__nF9oZq__eyebrow",
  "feature": "mojumoncrimson-module__nF9oZq__feature",
  "feature-strip": "mojumoncrimson-module__nF9oZq__feature-strip",
  "fineprint": "mojumoncrimson-module__nF9oZq__fineprint",
  "float": "mojumoncrimson-module__nF9oZq__float",
  "footer": "mojumoncrimson-module__nF9oZq__footer",
  "fusion-alert": "mojumoncrimson-module__nF9oZq__fusion-alert",
  "fusion-case": "mojumoncrimson-module__nF9oZq__fusion-case",
  "fusion-core": "mojumoncrimson-module__nF9oZq__fusion-core",
  "fusion-dots": "mojumoncrimson-module__nF9oZq__fusion-dots",
  "fusion-grid": "mojumoncrimson-module__nF9oZq__fusion-grid",
  "fusion-heading": "mojumoncrimson-module__nF9oZq__fusion-heading",
  "fusion-lab": "mojumoncrimson-module__nF9oZq__fusion-lab",
  "fusion-meta": "mojumoncrimson-module__nF9oZq__fusion-meta",
  "fusion-note": "mojumoncrimson-module__nF9oZq__fusion-note",
  "fusion-parent": "mojumoncrimson-module__nF9oZq__fusion-parent",
  "fusion-parent-left": "mojumoncrimson-module__nF9oZq__fusion-parent-left",
  "fusion-parent-right": "mojumoncrimson-module__nF9oZq__fusion-parent-right",
  "fusion-result": "mojumoncrimson-module__nF9oZq__fusion-result",
  "fusion-silhouette": "mojumoncrimson-module__nF9oZq__fusion-silhouette",
  "fusion-stage": "mojumoncrimson-module__nF9oZq__fusion-stage",
  "fusionBurst": "mojumoncrimson-module__nF9oZq__fusionBurst",
  "fusionCore": "mojumoncrimson-module__nF9oZq__fusionCore",
  "fusionDots": "mojumoncrimson-module__nF9oZq__fusionDots",
  "fusionFlash": "mojumoncrimson-module__nF9oZq__fusionFlash",
  "fusionLeft": "mojumoncrimson-module__nF9oZq__fusionLeft",
  "fusionReveal": "mojumoncrimson-module__nF9oZq__fusionReveal",
  "fusionRight": "mojumoncrimson-module__nF9oZq__fusionRight",
  "fusionSparks": "mojumoncrimson-module__nF9oZq__fusionSparks",
  "fusionStageShake": "mojumoncrimson-module__nF9oZq__fusionStageShake",
  "hero": "mojumoncrimson-module__nF9oZq__hero",
  "hero-copy": "mojumoncrimson-module__nF9oZq__hero-copy",
  "hero-sprite": "mojumoncrimson-module__nF9oZq__hero-sprite",
  "hero-tags": "mojumoncrimson-module__nF9oZq__hero-tags",
  "heroes": "mojumoncrimson-module__nF9oZq__heroes",
  "heroes-art": "mojumoncrimson-module__nF9oZq__heroes-art",
  "heroes-copy": "mojumoncrimson-module__nF9oZq__heroes-copy",
  "heroes-panel": "mojumoncrimson-module__nF9oZq__heroes-panel",
  "id-lines": "mojumoncrimson-module__nF9oZq__id-lines",
  "is-active": "mojumoncrimson-module__nF9oZq__is-active",
  "journal-hotspot": "mojumoncrimson-module__nF9oZq__journal-hotspot",
  "loop": "mojumoncrimson-module__nF9oZq__loop",
  "loop-arrow": "mojumoncrimson-module__nF9oZq__loop-arrow",
  "loop-grid": "mojumoncrimson-module__nF9oZq__loop-grid",
  "loop-icon": "mojumoncrimson-module__nF9oZq__loop-icon",
  "loop-step": "mojumoncrimson-module__nF9oZq__loop-step",
  "micro": "mojumoncrimson-module__nF9oZq__micro",
  "modal": "mojumoncrimson-module__nF9oZq__modal",
  "modal-box": "mojumoncrimson-module__nF9oZq__modal-box",
  "modal-close": "mojumoncrimson-module__nF9oZq__modal-close",
  "moju-parade": "mojumoncrimson-module__nF9oZq__moju-parade",
  "next": "mojumoncrimson-module__nF9oZq__next",
  "note-card": "mojumoncrimson-module__nF9oZq__note-card",
  "notes-box": "mojumoncrimson-module__nF9oZq__notes-box",
  "notes-close": "mojumoncrimson-module__nF9oZq__notes-close",
  "notes-grid": "mojumoncrimson-module__nF9oZq__notes-grid",
  "notes-lead": "mojumoncrimson-module__nF9oZq__notes-lead",
  "notes-modal": "mojumoncrimson-module__nF9oZq__notes-modal",
  "page": "mojumoncrimson-module__nF9oZq__page",
  "parade-chip": "mojumoncrimson-module__nF9oZq__parade-chip",
  "parade-copy": "mojumoncrimson-module__nF9oZq__parade-copy",
  "parade-mon": "mojumoncrimson-module__nF9oZq__parade-mon",
  "parade-set": "mojumoncrimson-module__nF9oZq__parade-set",
  "parade-track": "mojumoncrimson-module__nF9oZq__parade-track",
  "parade-viewport": "mojumoncrimson-module__nF9oZq__parade-viewport",
  "paradeBob": "mojumoncrimson-module__nF9oZq__paradeBob",
  "paradeLTR": "mojumoncrimson-module__nF9oZq__paradeLTR",
  "pixel-font": "mojumoncrimson-module__nF9oZq__pixel-font",
  "professor-dialogue": "mojumoncrimson-module__nF9oZq__professor-dialogue",
  "professor-intro": "mojumoncrimson-module__nF9oZq__professor-intro",
  "professor-name": "mojumoncrimson-module__nF9oZq__professor-name",
  "professor-portrait": "mojumoncrimson-module__nF9oZq__professor-portrait",
  "professor-visual": "mojumoncrimson-module__nF9oZq__professor-visual",
  "professorArrive": "mojumoncrimson-module__nF9oZq__professorArrive",
  "professorIdle": "mojumoncrimson-module__nF9oZq__professorIdle",
  "replay-fusion": "mojumoncrimson-module__nF9oZq__replay-fusion",
  "reveal-sparks": "mojumoncrimson-module__nF9oZq__reveal-sparks",
  "roster-head": "mojumoncrimson-module__nF9oZq__roster-head",
  "round": "mojumoncrimson-module__nF9oZq__round",
  "route-label": "mojumoncrimson-module__nF9oZq__route-label",
  "scanlines": "mojumoncrimson-module__nF9oZq__scanlines",
  "screen": "mojumoncrimson-module__nF9oZq__screen",
  "screen-bezel": "mojumoncrimson-module__nF9oZq__screen-bezel",
  "screen-dialogue": "mojumoncrimson-module__nF9oZq__screen-dialogue",
  "screen-head": "mojumoncrimson-module__nF9oZq__screen-head",
  "section": "mojumoncrimson-module__nF9oZq__section",
  "section-inner": "mojumoncrimson-module__nF9oZq__section-inner",
  "section-intro": "mojumoncrimson-module__nF9oZq__section-intro",
  "section-kicker": "mojumoncrimson-module__nF9oZq__section-kicker",
  "selected": "mojumoncrimson-module__nF9oZq__selected",
  "site-shell": "mojumoncrimson-module__nF9oZq__site-shell",
  "sprite-window": "mojumoncrimson-module__nF9oZq__sprite-window",
  "spriteIn": "mojumoncrimson-module__nF9oZq__spriteIn",
  "starter-card": "mojumoncrimson-module__nF9oZq__starter-card",
  "starter-dot": "mojumoncrimson-module__nF9oZq__starter-dot",
  "starter-dots": "mojumoncrimson-module__nF9oZq__starter-dots",
  "starter-grid": "mojumoncrimson-module__nF9oZq__starter-grid",
  "starter-name": "mojumoncrimson-module__nF9oZq__starter-name",
  "starter-stage": "mojumoncrimson-module__nF9oZq__starter-stage",
  "starters": "mojumoncrimson-module__nF9oZq__starters",
  "step-no": "mojumoncrimson-module__nF9oZq__step-no",
  "tamer-card": "mojumoncrimson-module__nF9oZq__tamer-card",
  "tamer-controls": "mojumoncrimson-module__nF9oZq__tamer-controls",
  "tamer-copy": "mojumoncrimson-module__nF9oZq__tamer-copy",
  "tamer-description": "mojumoncrimson-module__nF9oZq__tamer-description",
  "tamer-file": "mojumoncrimson-module__nF9oZq__tamer-file",
  "tamer-focus": "mojumoncrimson-module__nF9oZq__tamer-focus",
  "tamer-id": "mojumoncrimson-module__nF9oZq__tamer-id",
  "tamer-in": "mojumoncrimson-module__nF9oZq__tamer-in",
  "tamer-intro-panel": "mojumoncrimson-module__nF9oZq__tamer-intro-panel",
  "tamer-name": "mojumoncrimson-module__nF9oZq__tamer-name",
  "tamer-nav": "mojumoncrimson-module__nF9oZq__tamer-nav",
  "tamer-number": "mojumoncrimson-module__nF9oZq__tamer-number",
  "tamer-page": "mojumoncrimson-module__nF9oZq__tamer-page",
  "tamer-role": "mojumoncrimson-module__nF9oZq__tamer-role",
  "tamer-roster": "mojumoncrimson-module__nF9oZq__tamer-roster",
  "tamer-route": "mojumoncrimson-module__nF9oZq__tamer-route",
  "tamer-side": "mojumoncrimson-module__nF9oZq__tamer-side",
  "tamer-sprite": "mojumoncrimson-module__nF9oZq__tamer-sprite",
  "tamer-stage": "mojumoncrimson-module__nF9oZq__tamer-stage",
  "tamer-status": "mojumoncrimson-module__nF9oZq__tamer-status",
  "tamer-tags": "mojumoncrimson-module__nF9oZq__tamer-tags",
  "tamer-thumb": "mojumoncrimson-module__nF9oZq__tamer-thumb",
  "tamer-thumbs": "mojumoncrimson-module__nF9oZq__tamer-thumbs",
  "tamer-toggle": "mojumoncrimson-module__nF9oZq__tamer-toggle",
  "tamer-viewport": "mojumoncrimson-module__nF9oZq__tamer-viewport",
  "tamerIn": "mojumoncrimson-module__nF9oZq__tamerIn",
  "tamerTextIn": "mojumoncrimson-module__nF9oZq__tamerTextIn",
  "textCaret": "mojumoncrimson-module__nF9oZq__textCaret",
  "threat": "mojumoncrimson-module__nF9oZq__threat",
  "threat-art": "mojumoncrimson-module__nF9oZq__threat-art",
  "threat-code": "mojumoncrimson-module__nF9oZq__threat-code",
  "threat-copy": "mojumoncrimson-module__nF9oZq__threat-copy",
  "threat-file": "mojumoncrimson-module__nF9oZq__threat-file",
  "threat-tags": "mojumoncrimson-module__nF9oZq__threat-tags",
  "type": "mojumoncrimson-module__nF9oZq__type",
  "typing": "mojumoncrimson-module__nF9oZq__typing",
  "wilting": "mojumoncrimson-module__nF9oZq__wilting",
});
